import { BlockSize } from 'aos-helpers/src/helpers/Block'
import { Color } from 'aos-ui-common/src/styles/Color'
import React, { FCWithChildren } from 'react'
import styled from 'styled-components'

import { boxShadow } from '../base/Theme'
import { IconButton } from '../buttons/IconButton'
import { IconVariant } from '../svg/Icon'
import { SvgIcon } from '../svg/SvgIcon'

interface AttachmentEditToolbarProps {
    rotateLeft?(): void
    rotateRight?(): void
    reset?(): void
    save?(): void
}

type ButtonDef = [Svg, (() => void) | undefined]

export const AttachmentEditToolbar: FCWithChildren<AttachmentEditToolbarProps> = ({
    rotateLeft,
    rotateRight,
    reset,
    save,
}) => {
    const buttons: ButtonDef[] = [
        [SvgIcon.RotateLeft, rotateLeft],
        [SvgIcon.RotateRight, rotateRight],
        [SvgIcon.Close, reset],
        [SvgIcon.Done, save],
    ]

    return (
        <Wrapper>
            {buttons.map(([icon, action], index) => (
                <IconButton
                    margin={8}
                    key={index}
                    iconSize={BlockSize.Std}
                    iconVariant={IconVariant.White}
                    svg={icon}
                    disabled={!action}
                    onClick={action}
                />
            ))}
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: inline-flex;
    background-color: ${Color.ChartBase};
    border-radius: 3px;
    pointer-events: all;
    text-align: center;
    box-shadow: ${boxShadow.std};
`
